var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.6C19 16.5823 16.5823 19 13.6 19C10.6177 19 8.2 16.5823 8.2 13.6C8.2 9.71766 13.6 1 13.6 1C13.6 1 19 9.71766 19 13.6Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 7.3C6.4 8.79117 5.19117 10 3.7 10C2.20883 10 1 8.79117 1 7.3C1 5.35883 3.7 1 3.7 1C3.7 1 6.4 5.35883 6.4 7.3Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcWater);
export default __webpack_public_path__ + "static/media/pc-water.dc3854b0f7adfcf767fccadf7bb2703e.svg";
export { ForwardRef as ReactComponent };